module.exports = __webpack_public_path__ + "static/media/trash.d94fea26.svg";